$(function () {
	$(window).on("load", function () {
		getSectionHeights();
	});

	var sectionHeights = {};

	function getSectionHeights() {
		sectionHeights = {
			"#product_feature": $("#product_feature").outerHeight(),
			"#color_lineup": $("#color_lineup").outerHeight(),
			"#how_to_use": $("#how_to_use").outerHeight(),
		};
	}

	$(window).on("resize", function () {
		getSectionHeights();
	});

	$(".footer_nav li a").on("click", function (event) {
		event.preventDefault();
		var target = $(this).attr("href");
		var targetOffset = $(target).offset().top;
		// 元々lenisでスクロールしていた箇所なので削除 or 普通のスクロールにする
		$("html, body").animate({ scrollTop: targetOffset }, 600);
	});
});

$(function () {
	$(".btn_flow .infiniteslideL").infiniteslide({
		speed: 50,
		direction: "left",
		pauseonhover: !1,
		responsive: !1,
		clone: 10,
	});

	$(".btn_flow .infiniteslideR").infiniteslide({
		speed: 50,
		direction: "right",
		pauseonhover: !1,
		responsive: !1,
		clone: 10,
	});
});

function slideAnime() {
	$(".slide_left_anm").each(function () {
		var elemPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		var threshold = windowHeight * (4 / 5);
		if (scroll >= elemPos - threshold) {
			$(this).addClass("slideAnimeLeftRight");
			$(this).children(".slide_left_anm_inner").addClass("slideAnimeRightLeft");
			$(this).css({ opacity: "1", transform: "translateX(0)" });
			$(this).children(".slide_left_anm_inner").css({ opacity: "1", transform: "translateX(0)" });
		}
	});
}

$(window).scroll(function () {
	slideAnime();
});

function fadeinAnm() {
	var target = $(".is-anm");
	var h = window.innerHeight;
	$(window).on("scroll", function () {
		var ScrTop = $(window).scrollTop();
		target.each(function () {
			var imgPos = $(this).offset().top;
			if (ScrTop > imgPos - h * (4 / 5)) {
				$(this).addClass("is-done");
			}
		});
	});
	$(window).scroll();
}

$(function () {
	fadeinAnm();
});

$(window).scroll(function () {
	if ($(window).scrollTop() > 0) {
		$(".fixLink").fadeIn();
	} else {
		$(".fixLink").fadeOut();
	}
});

$(function () {
	$(".js-acc").next(".child").hide(0);
	$(".js-acc").click(function () {
		var $child = $(this).closest(".parent").next(".child");
		$child.slideToggle();
		$(this).toggleClass("is-open");
	});
});

$(function () {
	$(".animated-link").each(function () {
		var text = $(this).text();
		$(this).html("");
		for (var i = 0; i < text.length; i++) {
			var span = $("<span>");
			span.text(text[i] === " " ? "\xA0" : text[i]);
			span.css("animation-delay", i * 0.05 + "s");
			$(this).append(span);
		}
	});
});

let chart29Initialized = !1;
let chart35Initialized = !1;

function createChart(ctx, data) {
	return new Chart(ctx, {
		type: "doughnut",
		data: {
			datasets: [
				{
					data,
					backgroundColor: ["rgb(123, 138, 161)", "rgba(255, 255, 255, 0)"],
					borderWidth: 0,
					hoverOffset: 0,
				},
			],
		},
		options: {
			responsive: !0,
			maintainAspectRatio: !1,
			cutout: "60%",
			plugins: {
				tooltip: {
					enabled: !1,
				},
			},
			animation: {
				animateRotate: !0,
				duration: 1000,
			},
			hover: {
				mode: null,
			},
		},
	});
}

$(function () {

	//KVのスライダー
	// const slides = $('.mv_slde_block');
	// const length = slides.length;
	// let current = 0;
	// let lastChange = Date.now();
	// const interval = 3000;

	// if (length < 2) return;

	// slides.css('z-index', 0);
	// slides.eq(current).css('z-index', 2);
	// slides.eq((current + 1) % length).css('z-index', 1);

	// function loop() {
	// 	const now = Date.now();
	// 	if (now - lastChange >= interval) {
	// 		current = (current + 1) % length;
	// 		lastChange = now;

	// 		slides.css('z-index', 0);
	// 		slides.removeClass('is-active');
	// 		slides.eq(current).css('z-index', 2).addClass('is-active');
	// 		slides.eq((current - 1 + length) % length).css('z-index', 1);
	// 	}
	// 	requestAnimationFrame(loop);
	// }

	// requestAnimationFrame(loop);

	document.addEventListener("DOMContentLoaded", () => {
		setUpAccordion();
	});

	$('.campaign_btn').on('click', function () {
		$(this).toggleClass('is-open');
		$('.campaign_detail').slideToggle();
	});

});
$(function () {
	$(".js-summary").on("click", function (e) {

		const $details = $(this).parent('.js-details');
		const $content = $details.find(".js-content");
		$(this).toggleClass('is-open');
		$content.slideToggle();

	});
});

document.addEventListener('DOMContentLoaded', () => {
	let splide = null; // Splideインスタンスを保持
	const target = '.splide';

	function initOrDestroySplide() {
		if (window.matchMedia('(max-width: 896px)').matches) {
			// 896px 以下 → Splideを有効化
			if (!splide) {
				splide = new Splide(target, {
					type: 'slide',       // ← ループではなくスライド方式に
					focus: 'center',
					fixedWidth: '28rem',
					perMove: 1,
					gap: '2rem',
					trimSpace: false,
					rewind: false,

				});
				splide.mount();
			}
		} else {
			// 897px 以上 → Splideを破棄してリストに戻す
			if (splide) {
				splide.destroy(true); // true = DOMやstyleをクリーンアップ
				splide = null;
			}
		}
	}

	// 初期実行
	initOrDestroySplide();

	// リサイズごとに判定
	window.addEventListener('resize', initOrDestroySplide);
});